import { render, staticRenderFns } from "./Trx.vue?vue&type=template&id=64120254&scoped=true&lang=pug"
import script from "./Trx.vue?vue&type=script&lang=js"
export * from "./Trx.vue?vue&type=script&lang=js"
import style0 from "./Trx.vue?vue&type=style&index=0&id=64120254&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64120254",
  null
  
)

export default component.exports